<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="users"
        class="elevation-0 mt-2 mb-2 mx-3 light-regular-font"
        :no-data-text="i18n('Nenhum usuário registrado')"
        hide-actions
      >
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.username }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ humanStatus(props.item.status) }}</td>
          <td class="text-xs-center">
            {{ whitelistedVerifier(props.item.ip_list) }} <br/>
            <small v-if="props.item.ip_list && props.item.ip_list.length > 0">
              ({{ props.item.ip_list.length }} IPs whitelisted)
            </small>
          </td>
          <td class="text-xs-center">
            <v-icon class="material-icons"> {{ props.item.is_password_set ? "check_circle" : "highlight_off" }}</v-icon>
          </td>
          <td class="text-xs-center px-0">
            <v-icon small class="mr-2" @click="openEditUserForm(props.item, company_id)">edit</v-icon>
          </td>
        </template>
      </v-data-table>
      <v-btn color="#0e9e98de" dark small absolute top right fab
        @click="openNewUserForm(company_id)"
        v-if="$root.userAllowedTo('users-create') || is_admin">
        <v-icon>add</v-icon>
      </v-btn>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'Users',
  props: {
    company_id: {
      type: String
    },
    users_list: {
      type: Array
    },
    is_admin: {
      type: Boolean,
      default: false
    }
  },
  data(vm) {
    return {
      users: [],
      headers: [
        { text: vm.i18n('Usuário'), value: 'username', align: 'left', sortable: false },
        { text: vm.i18n('Nome'), value: 'name', align: 'left', sortable: false },
        { text: vm.i18n('Status'), value: 'status', align: 'left', sortable: false },
        { text: vm.i18n('Whitelisted'), value: 'whitelisted', align: 'center', sortable: false },
        { text: vm.i18n('Senha definida?'), value: 'ispwdset', align: 'center', sortable: false },
        { text: vm.i18n('Ação'), value: 'action', align: 'center', sortable: false }
      ]
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    humanStatus(str) {
      if (str == 'active') {
        return this.i18n('Ativo')
      }
      if (str == 'not_active') {
        return this.i18n('Não Ativo')
      }
      if (str == null) {
        return this.i18n('Não Ativo')
      }
      return str
    },
    whitelistedVerifier(ipList) {
      if (!Array.isArray(ipList) || ipList.length === 0) {
        return this.i18n("Não")
      }
      return `${this.i18n("Sim")}`
    },
    loadUsers() {
      let successCallback = (response) => {
        if (response.body.data) {
          this.users = response.body.data
        } else {
          console.log(response)
        }
      }

      let errorCallback = (response) => {
        console.log(response)
      }

      const token = this.$cookies.get('api_token')
      this.$http.get(this.endpoint_url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback, errorCallback)
    },
    openNewUserForm(company_id) {
      this.$root.$emit('openNewUserForm', company_id)
    },
    openEditUserForm(user, company_id) {
      this.$root.$emit('openEditUserForm', user, company_id)
    }
  },
  computed: {
    endpoint_url() {
      return this.company_id
      ? this.$root.urls.admin__company_user__id.split('ID').join(this.company_id)
      : this.$root.urls.users
    }
  },
  mounted() {
    const has_registered_company = this.$cookies.isKey('company_id') && this.$cookies.get('company_id') !== ''

    if (!has_registered_company) {
      this.$router.push('/dashboard')
      return
    }

    if (this.users_list) { this.users = this.users_list }
    else this.loadUsers()

    this.$root.$on('userCreated', (_created_user) => {
      this.loadUsers()
    })
    this.$root.$on('userUpdated', (updated_user) => {
      const index = this.users.findIndex(x => x.id == updated_user.id)
      this.users.splice(index, 1, updated_user)
    })
  },
  metaInfo: {
    title: "Facilita Pay"
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Users.vue